<template>
    <div class="details">
        <div class="myAnswer">
            <div class="top">
                <div class="header">
                    <span class="frist">我的答案</span>
                    <span class="fen">（得分{{ echoedData.userScore }}分）</span>
                </div>
                <div class="content">
                    <p>{{ echoedData.userAnswer }}</p>
                </div>
            </div>
            <div class="fujian">
                <div
                    class="appendix"
                    v-for="(item, idx) in echoedData.fileList"
                    :key="idx"
                    @click="changeAppendix(item)"
                >
                    <img v-if="item.type == 1" class="video" :src="item.url" alt="" />
                    <img v-if="item.type == 2" class="video" src="./video.png" alt="" />
                    <a
                        v-else-if="item.type == 3"
                        :href="'http://www.xdocin.com/xdoc?_func=to&_format=html&_cache=1&_xdoc=' + item.url"
                        rel="nofollow"
                    >
                        <img class="word" src="./word.png" alt="" />
                    </a>
                    <img v-else-if="item.type == 4" class="zip" src="./zip.png" alt="" />
                </div>
            </div>
        </div>
        <div class="jiexi">
            <div class="item" v-if="echoedData.rightAnswer">
                <span class="header">正确答案</span>
                <div class="content">
                    <p v-html="echoedData.rightAnswer"></p>
                </div>
            </div>
            <div class="item" v-if="echoedData.remark">
                <span class="header">试题解析</span>
                <div class="content">
                    <p v-html="echoedData.remark"></p>
                </div>
            </div>
        </div>

        <!-- 查看弹出层 -->
        <van-overlay :show="overlay" @click="changeOverlay">
            <div class="wrapper">
                <div class="block">
                    <img v-if="current.type == 1" :src="current.url" alt="" />
                    <video @click.stop ref="video" autoplay v-else-if="current.type == 2" controls :src="current.url" />
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    props: {
        echoedData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    watch: {
        echoedData: {
            handler(newVal) {
                this.getFileUri(newVal)
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            overlay: false,
            current: {}
        }
    },
    methods: {
        // 获取附件list
        getFileUri(newVal) {
            if (newVal.uri) {
                let uri = JSON.parse(newVal.uri)
                // 1图片 2音视频 3文档 4压缩包
                const typeObj = {
                    jpg: 1,
                    jpeg: 1,
                    png: 1,
                    gif: 1,
                    heic: 1,
                    mp3: 2,
                    mp4: 2,
                    mov: 2,
                    pdf: 3,
                    doc: 3,
                    docx: 3,
                    xls: 3,
                    xlsx: 3,
                    rar: 4,
                    zip: 4
                }
                uri.forEach(val => {
                    let typeName = val.name.replace(/.+\./, '').toLowerCase()
                    val.type = typeObj[typeName]
                })
                newVal.fileList = uri
            }
        },
        changeOverlay() {
            if (this.current.type == 2) {
                this.$refs.video.pause()
            }
            this.overlay = false
        },
        changeAppendix(item) {
            console.log(item, 'changeAppendix', 444)
            // 1图片 2音视频 3文档 4压缩包
            // if ([3, 4].includes(item.type)) return
            if (item.type == 4) return
            if (item.type == 3) {
                sessionStorage.setItem('previewArea', true)
            } else {
                this.overlay = true
                this.current = item
            }
        },
    },
}
</script>

<style lang="less" scoped>
.details {
    .myAnswer {
        .top {
            width: 670px;
            min-height: 200px;
            max-height: 500px;
            border-radius: 16px;
            border: 1px solid #eaeaea;
            padding: 24px 16px 0 16px;
            overflow-y: auto;
            box-sizing: border-box;
            margin-bottom: 31px;
            .header {
                margin-bottom: 12px;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                .frist {
                    font-weight: 600;
                    color: #333333;
                }
                .fen {
                    color: #ff8b32;
                }
            }
            .content {
                p {
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 40px;
                }
            }
        }
        .fujian {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 39px;
            .appendix {
                width: 158px;
                height: 158px;
                margin-right: 14px;
                margin-bottom: 14px;
                img {
                    width: 100%;
                    height: 100%;
                }
                &:nth-child(4) {
                    margin-right: 0;
                }
            }
        }
    }
    .jiexi {
        width: 670px;
        background: #f7f7f7;
        border-radius: 16px;
        padding: 24px 16px;
        .item {
            margin-bottom: 24px;
            &:last-child {
                margin-bottom: 0;
            }
            .header {
                line-height: 36px;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #415ff6;
                margin-bottom: 12px;
            }
            .content {
                p {
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #202124;
                    line-height: 40px;
                }
            }
        }
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        .block {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 100%;
            }
            video {
                width: 70%;
            }
        }
    }
}
</style>
